<!--
 * @Description: 销售线索 - 详情页面
 * @Author: mdb
 * @Date: 2022-07-06 11:33:06
 * @LastEditTime: 2023-03-15 18:02:13
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="dataForm?.customerName"
        :sellerName="dataForm?.followerName"
        :customLabel="t('clue.clueType')"
        :customValue="clueTypeComputed"
      >
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" :tab="t('common.baseTabs')">
            <DetailForm ref="detailFormRef" type="view" :isEdit="false" v-model:value="dataForm" />
            <!---审批记录的页面过来的：/ofbu/customerProcessing/cluesAudit--->
            <ApplyRecord :title="t('common.applayTitle')" v-if="route.query.isApplay === '1'" />
          </a-tab-pane>
          <a-tab-pane key="contact" :tab="t('common.concatTabs')">
            <TabsContacts
              ref="contactsRef"
              appId="cos_ofbu"
              :contactRefId="queryClueId"
              :permissionPage="permissionConcat"
            />
          </a-tab-pane>
          <a-tab-pane key="record" :tab="t('common.followTabs')">
            <TabsClueCosFollowUp :permissionPage="permissionFollow" appId="cos_ofbu" :followRefId="queryClueId" />
          </a-tab-pane>
          <a-tab-pane key="convert" :tab="t('common.conversionTabs')">
            <TabsConversion :resourceId="queryClueId" appId="cos_ofbu" />
          </a-tab-pane>
          <a-tab-pane key="logs" :tab="t('common.operationLogTabs')">
            <TabsOperationLog
              ref="operationLogRef"
              appId="cos_ofbu"
              :resourceId="queryClueId"
              tableId="FbuSalesClueOperationLog"
            />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <a-button v-permission="permissionConcat.add" @click="handleAddConcat()">{{ t('btn.addContact') }}</a-button>
      <template v-if="!isPublicClue">
        <SellerButton
          v-permission="'ofbu_clue_edit_btn'"
          controlType="none"
          @click="goToEdit()"
          >{{ t('btn.edit') }}</SellerButton
        >
        <a-button v-permission="'ofbu_clue_person_btn'" @click="handleAssignPerson()">{{
          t('btn.personClue')
        }}</a-button>
<!--        <SellerButton-->
<!--          v-permission="'ofbu_clue_potential_btn'"-->
<!--          :workCode="dataForm.follower"-->
<!--          controlType="none"-->
<!--          @click="handleTurnPotential()"-->
<!--          v-if="dataForm.clueStatus !== 8"-->
<!--          >{{ t('btn.toPotential') }}</SellerButton-->
<!--        >-->
      </template>
      <a-button
        v-permission="'ofbu_clue_write_follow_btn'"
        type="primary"
        @click="handleWriteFollowUp()"
        v-if="!isPublicClue"
        >{{ t('btn.writeFollow') }}</a-button
      >
    </cos-footer-button>
  </dc-layout-main>

  <!-- 分配客户负责人弹窗 -->
  <ClueAssign ref="clueAssignRef" @fetch="handleAssignPersonSuccess" />
  <!-- 新增联系人弹窗 -->
  <ConcatModal ref="concatModalRef" @success="successAddConcat" :contactRefId="queryClueId" />
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import TabsConversion from '@/components/TabsConversion'
import ApplyRecord from './components/ApplyRecord.vue'
import ClueAssign from '../components/ClueAssign.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ConcatModal from '@/components/TabsContacts/ofbu/editModal.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/overseasSales/clueManage'
import { clueTypeEnum } from '@/views/overseasSales/clueManage/dataConfig'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const permissionFollow = {
  edit: 'ofbu_clue_follow_edit_btn',
  del: 'ofbu_clue_follow_del_btn',
  comment: 'ofbu_clue_follow_comment_btn'
}
const permissionConcat = {
  add: 'ofbu_clue_contact_add_btn',
  edit: 'ofbu_clue_contact_edit_btn',
  del: 'ofbu_clue_contact_del_btn'
}

const queryClueId = computed(() => route.query.clueId as string)
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
const clueTypeComputed = computed(() => {
  const find = clueTypeEnum.find((item) => item.value === dataForm?.clueType)
  if (find?.lang) {
    return t(find.lang)
  }
  return find?.label
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})

const getDetails = () => {
  salesClueDetail({ clueId: queryClueId.value }).then((res) => {
    if (res.data.remindFlag === true) {
      res.data.remindFlag = 1
    } else if (res.data.remindFlag === false) {
      res.data.remindFlag = 0
    } else {
      res.data.remindFlag = undefined
    }
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => getDetails())

const activeTabs = ref('info')
const operationLogRef = ref()
const handleTabsChange = (val: any) => {
  if (val === 'info') {
    getDetails()
  } else if (val === 'logs') {
    operationLogRef.value?.fetch()
  }
}
const goToEdit = () => {
  router.push({ path: '/ofbu/salesClue/edit', query: { clueId: queryClueId.value } })
}
// 新增联系人
const contactsRef = ref()
const concatModalRef = ref()
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successAddConcat = (type: any) => {
  contactsRef.value?.refresh(type)
  operationLogRef.value?.fetch()
  getDetails()
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  const data = [toRaw(dataForm)]
  clueAssignRef.value?.init(data)
}
const handleAssignPersonSuccess = (follower: string) => {
  getDetails()
  dataForm.follower = follower
}

// 跳转跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: { followRefId: queryClueId.value }
  })
}

// // 转潜在客户
// const handleTurnPotential = () => {
//   if (dataForm.clueType === 3) return message.warning(t('tips.TSAOjPMnA'))
//   if (dataForm.dataIntegrity !== 100) {
//     AModal.confirm({
//       title: t('tips.Tvsfe9j3Z'),
//       content: t('tips.NtJGazd'),
//       okText: t('btn.complete'),
//       onOk() {
//         router.push({ path: '/ofbu/salesClue/edit', query: { clueId: dataForm.clueId, isPerfect: 'required' } })
//       },
//       // eslint-disable-next-line @typescript-eslint/no-empty-function
//       onCancel() {}
//     })
//   } else {
//     router.push({
//       path: '/ofbu/business/add',
//       query: { saleChanceRefId: dataForm.clueId, isFromPotentialCustomer: 1 }
//     })
//   }
// }
</script>
<script lang="ts">
export default { name: 'DcCosOFbuSalesClueView' }
</script>

<style scoped></style>
